import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { brandedGameIds } from '../enums/brandedPartners';

export const isBetFair = () => {
  // const { [DefaultQueryParams.PartnerId]: partnerId } = parseQuery(window.location.search);
  const { gameId } = gameConfigStore;
  return +gameId === +brandedGameIds.betfair;
};
